"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.checkAction = function () {
    var actionTypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actionTypes[_i] = arguments[_i];
    }
    return function (action) { return lodash_1.flow(function (ac) { return lodash_1.findIndex(actionTypes, function (acc) { return acc === ac.type; }); }, function (found) { return found > -1; })(action); };
};
//# sourceMappingURL=checkAction.js.map